<div class="card-layout">
  <div class="header d-flex justify-content-between" [class.extraSpacingBelowTitle]="!disableHeaderSpacing">
    <span class="title">{{ title }}</span>

    <ng-content select="[header]"></ng-content>
  </div>

  <ng-content></ng-content>
</div>
